module.exports = __webpack_public_path__ + "img/dea-formazione-ico-mediazione-didattica.4ae9c990.svg";